import { Button } from "@/components/Base/Button";
import { useIsAuthenticated } from "@/hooks/useIsAuthenticated";
import { shop } from "@/repositories/shop";
import { httpsCallables } from "@/repositories/httpsCallables";

const DebugPage = () => {
  useIsAuthenticated();
  const handleListShops = () => {
    shop.listShops().then((res) => console.log(res));
  };

  const handleReconcileLabelSyncCount = () => {
    const shopId = window.prompt("Shop doc id to recalculate the count for?");
    if (!shopId) return;
    httpsCallables
      .reconcileLabelSyncInFlight({ shopId })
      .then((res) => console.log(res.data))
      .catch((err) => console.error(err));
  };

  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">Debug Page</h1>
      <div className="flex flex-wrap gap-2">
        <Button onClick={handleListShops} variant="secondary">
          List Shops
        </Button>
        <Button onClick={handleListShops} variant="secondary">
          List Shops for Current Uer
        </Button>
        <Button onClick={handleReconcileLabelSyncCount} variant="secondary">
          Reconcile Label Sync Count
        </Button>
      </div>
    </div>
  );
};

export default DebugPage;
